

import ProductsCard from '../components/ProductsCard';
import productsData from '../data/productsData';


export default function Home() {

 
  return (
    <div>
      
      <selection id="home">
        <div className="container">
          <div className="home_content">
            {
              productsData.map((item)=>(
                <ProductsCard key={item.id}{...item}></ProductsCard>
              ))
            }
          </div>
        </div>
      </selection>
      </div>


  )
}
